import { render, staticRenderFns } from "./DeviceApkList.vue?vue&type=template&id=50055e6b&scoped=true"
import script from "./DeviceApkList.vue?vue&type=script&lang=js"
export * from "./DeviceApkList.vue?vue&type=script&lang=js"
import style0 from "./DeviceApkList.vue?vue&type=style&index=0&id=50055e6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50055e6b",
  null
  
)

export default component.exports